export default {
  getColors: function() {
    var colors = [];

    colors.push('#FF0000'); // Color 01 RED
    colors.push('#008000'); // Color 02 GREEN
    colors.push('#f1f100'); // Color 03 YELLOW
    colors.push('#0000FF'); // Color 04 BLUE
    colors.push('#00FF00'); // Color 05 LIME
    colors.push('#00FFFF'); // Color 06 AQUA
    colors.push('#FF00FF'); // Color 07 MAGENTA
    colors.push('#FF1493'); // Color 08 DEEPPINK
    colors.push('#F5F5DC'); // Color 09 BEIGE
    colors.push('#D3D3D3'); // Color 10 LIGHTGRAY
    colors.push('#800000'); // Color 11 MAROON
    colors.push('#ADD8E6'); // Color 12 LIGHTBLUE
    colors.push('#FFC0CB'); // Color 13 PINK
    colors.push('#808000'); // Color 14 OLIVE
    colors.push('#2f4f4f'); // Color 15 DARKSLATEGRAY
    colors.push('#00fa9a'); // Color 16 MEDIUMSPRINGGREEN
    colors.push('#fa8072'); // Color 17 SALMON
    // colors.push('#1234567'); // Color 18
    // colors.push('#1234567'); // Color 19
    // colors.push('#1234567'); // Color 20
    // colors.push('#1234567'); // Color 21
    // colors.push('#1234567'); // Color 22
    // colors.push('#1234567'); // Color 23
    // colors.push('#1234567'); // Color 24
    // colors.push('#1234567'); // Color 25
    // colors.push('#1234567'); // Color 26
    // colors.push('#1234567'); // Color 27
    // colors.push('#1234567'); // Color 28
    // colors.push('#1234567'); // Color 29
    // colors.push('#1234567'); // Color 30
    
    return colors;
  }
}